export function centsToDollars(cents) {
  const dollars = cents / 100
  return dollars.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  })
}

export function totalForUsersToDollars(cents, activeUsersCount) {
  return centsToDollars(cents * activeUsersCount)
}

const INTERVAL_TO_INTERVALY = {
  month: 'monthly',
  year: 'yearly',
}

export function intervalify(interval) {
  return INTERVAL_TO_INTERVALY[interval]
}
